module.exports = __webpack_public_path__ + "img/invite_wechat.1768119790257.png";